import { Link, LinkProps } from '@optimus-web/core';

const NewWindowLink = (props: LinkProps) => <Link target="_blank" rel="noreferrer noopener" {...props} />;

export default NewWindowLink;
